<template>
  <nav class="dashboard-footer" aria-label="大屏导航">
    <img class="footer-accent footer-accent--left"
      src="@/assets/navigation/footer-accent-left.png" alt="" aria-hidden="true" />
    <img class="footer-accent footer-accent--right"
      src="@/assets/navigation/footer-accent-right.png" alt="" aria-hidden="true" />
    <button
      type="button"
      class="nav-tab nav-tab--safety"
      :class="{ 'is-active': current === 1 }"
      :aria-current="current === 1 ? 'page' : null"
      @click="tabClick(1)"
    >食安指挥</button>
    <img class="nav-center-divider"
      src="@/assets/navigation/nav-center-divider.png" alt="" aria-hidden="true" />
    <button
      type="button"
      class="nav-tab nav-tab--inspection"
      :class="{ 'is-active': current === 3 }"
      :aria-current="current === 3 ? 'page' : null"
      @click="tabClick(3)"
    >数字巡检</button>
  </nav>
</template>

<script>
export default {
  props: {
    current: {
      default: 1,
    },
  },
  methods: {
    tabClick(current) {
      if (this.current === current) return;
      this.$router.replace(current === 1 ? "/safe" : "/check");
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.2396rem;
  display: flex;
  justify-content: center;
  gap: 0.0208rem;

  .footer-accent {
    position: absolute;
    bottom: 0;
    width: 2.125rem;
    max-width: calc((100% - 4.3958rem) / 2 - 0.1563rem);
    height: auto;
    pointer-events: none;

    &--left { left: 0.1563rem; }
    &--right { right: 0.1563rem; }
  }

  .nav-center-divider {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0.1719rem;
    height: 0.099rem;
    z-index: 1;
    pointer-events: none;
  }

  .nav-tab {
    flex: 0 0 2.1875rem;
    height: 0.2396rem;
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #d1d6de;
    font-family: "YouSheBiaoTiHei", sans-serif;
    font-size: 0.1042rem;
    font-style: italic;
    letter-spacing: 0.0104rem;
    line-height: 0.2396rem;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid #7dd9ff;
      outline-offset: 2px;
    }

    &.is-active {
      color: #fff;
      text-shadow: 0 0 0.0313rem #5acbff;
    }
  }

  .nav-tab--safety {
    padding-right: 0.3125rem;
    text-align: right;
    background-image: url("~@/assets/navigation/food-safety-inactive.png");

    &.is-active {
      background-image: url("~@/assets/navigation/food-safety-active.png");
    }
  }

  .nav-tab--inspection {
    padding-left: 0.3125rem;
    text-align: left;
    background-image: url("~@/assets/navigation/digital-inspection-inactive.png");

    &.is-active {
      background-image: url("~@/assets/navigation/digital-inspection-active.png");
    }
  }
}
</style>
